export const SET_WEEKS_COUNT = 'SET_WEEKS_COUNT';

export const setWeeksCount = weeksCount => ({ type: SET_WEEKS_COUNT, weeksCount });

const initialState = {
  weeksCount: 1,
};

export const excessInventoryReducer = (state = initialState, action) => {
  const { type, weeksCount } = action;

  switch (type) {
    case SET_WEEKS_COUNT:
      return {
        ...state,
        weeksCount,
      };
    default:
      return state;
  }
};
